export default __webpack_public_path__ + "static/media/17.f7e89938.jpg";